import axios, { AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import { baseUrl } from '../constatnts/Connections';
import { handleSuccess, handleError } from './server';
import { SearchDataKvizPitanjeDto } from '../model/searchDataDto';

export async function getKvizPitanje(data: SearchDataKvizPitanjeDto) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/kviz-pitanje/random`,
        data: data,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}

export async function getKvizLovacPitanjeRandom(level: number) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/kviz-lovac/pitanje/random`,
        data: { level },
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}

export async function markKvizLovacPitanjeOdgovoreno(kvizPitanjeId: string) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/kviz-lovac/pitanje/odgovoreno`,
        data: { kvizPitanjeId },
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}

export async function saveKvizLovacRezultat(data: { vremeMs: number; zivotaPreostalo: number }) {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        url: `${baseUrl}/kviz-lovac/rezultat`,
        data,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}

export async function getKvizLovacRangLista(limit: number = 50) {
    const options: AxiosRequestConfig = {
        method: 'GET',
        url: `${baseUrl}/kviz-lovac/rang-lista?limit=${limit}`,
    };
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}

export async function previewImportKvizPitanjaExcel(file: File) {
    const token = await localStorage.getItem('accessToken');

    const formData = new FormData();
    formData.append('file', file);

    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/kviz-pitanja/import-excel/preview`,
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
        },
        data: formData,
    };

    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}

export async function importKvizPitanjaExcel(file: File) {
    const token = await localStorage.getItem('accessToken');

    // FormData za upload fajla
    const formData = new FormData();
    formData.append('file', file);

    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/kviz-pitanja/import-excel`,
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
        },
        data: formData,
    };

    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function importLekcijaPitanjaExcel(file: File) {
    const token = await localStorage.getItem('accessToken');

    // FormData za upload fajla
    const formData = new FormData();
    formData.append('file', file);

    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/pitanja/import-excel`,
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
        },
        data: formData,
    };

    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}
export async function previewImportLekcijaPitanjaExcel(file: File) {
    const token = await localStorage.getItem('accessToken');

    // FormData za upload fajla
    const formData = new FormData();
    formData.append('file', file);

    const options: AxiosRequestConfig = {
        method: 'POST',
        url: `${baseUrl}/pitanja/import-excel/preview`,
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
        },
        data: formData,
    };

    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
}

// ---- Uvoz strukture (oblast / podoblast / lekcija) iz Excel-a ----
const uploadStruktura = async (url: string, file: File) => {
    const token = await localStorage.getItem('accessToken');
    const formData = new FormData();
    formData.append('file', file);

    const options: AxiosRequestConfig = {
        method: 'POST',
        url,
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
        },
        data: formData,
    };

    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handleError(error));
};

export async function previewImportStrukturaExcel(file: File) {
    return uploadStruktura(`${baseUrl}/struktura/import-excel/preview`, file);
}

export async function importStrukturaExcel(file: File) {
    return uploadStruktura(`${baseUrl}/struktura/import-excel`, file);
}

export async function downloadStrukturaSablon() {
    const token = await localStorage.getItem('accessToken');
    const options: AxiosRequestConfig = {
        method: 'GET',
        url: `${baseUrl}/struktura/import-excel/template`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
    };
    return axios(options);
}
